// extracted by mini-css-extract-plugin
module.exports = {"animate-height":"CardWrapper_animate-height__1O-ij","CardWrapper":"CardWrapper_CardWrapper__1n4HH","animateHeight":"CardWrapper_animateHeight__3xedV"};